import { HTMLAttributes } from 'react'
import { Box, Container, Grid, Typography } from '@mui/material'
import parse from 'html-react-parser'

import Form from '@/components/base/form'
import Spacer from '@/components/sections/spacer'

import { WPCF7FormField } from '@/types/wp'

export type FormProps = HTMLAttributes<HTMLDivElement> & {
  title?: string
  text?: string
  form_item: {
    fields: WPCF7FormField[]
    button: {
      text: string
    }
  }
  is_first?: boolean
}

const FormSection = ({ form_item, title, text, is_first, ...props }: FormProps) => {
  return (
    <Box {...props}>
      <Container>
        <Grid container>
          <Grid size={{ xs: 4, sm: 6 }} offset={{ sm: 1, md: 3 }}>
            <Box
              sx={(theme) => ({
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                borderRadius: theme.shape.borderRadius4,
                backgroundColor: theme.palette.surface.background,
                boxShadow: theme.shadows[2]
              })}
            >
              {title && (
                <Typography variant="h4" component={is_first ? 'h1' : 'h2'}>
                  {title}
                </Typography>
              )}
              <Spacer size="xxs" />
              {text && (
                <Typography variant="textRegular" color="text.primary" component="p">
                  {parse(text)}
                </Typography>
              )}
              <Spacer size="xxs" />
              <Form
                form_id={form_item.fields[0].formId.toString()}
                fields={form_item.fields}
                submit={{ text: form_item.button.text }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default FormSection
